
<template>
  <o-layout
    :has-sider="true"
    :class="$s.FeatureContainer"
  >
    <o-layout-sider
      v-if="pageData.featureSidebarNav"
      :class="$s.Sidebar"
      :width="280"
    >
      <o-nav
        :title="pageData.featureSidebarNav.title"
        :class="$s.NavLinks"
        variant="secondary"
        has-indicator
      >
        <o-nav-link
          v-for="(navLink, idx) in pageData.featureSidebarNav.data"
          :to="navLink.to"
          :key="idx"
        >
          {{ navLink.title }}
        </o-nav-link>
      </o-nav>
    </o-layout-sider>
    <o-layout-content>
      <o-nav
        :class="$s.MobileMenu"
        variant="secondary"
      >
        <o-nav-link
          :label="pageData.featureSidebarNav.title"
        >
          Features
          <template
            slot="children"
          >
            <o-nav-link
              v-for="(navLink, idx) in pageData.featureSidebarNav.data"
              :to="navLink.to"
              :key="idx"
            >
              {{ navLink.title }}
            </o-nav-link>
          </template>
        </o-nav-link>
      </o-nav>
      <o-heading
        size="display-2"
        element="h2"
        v-html="pageData.pageTitle"
      />
      <feature-section
        v-for="(section, index) in sections"
        :section="section"
        :bordered="index !== (sections.length - 1)"
        :key="index"
      />
    </o-layout-content>
  </o-layout>
</template>

<script>
import { OLayout, OLayoutSider, OLayoutContent } from 'orbit-ui/components/Layout';
import { ONav, ONavLink } from 'orbit-ui/components/Nav';
import { OHeading } from 'orbit-ui/components/Heading';
import { OAccordion } from 'orbit-ui/components/Accordion';

import FeatureSection from './FeatureSection.vue';

export default {
  name: 'FeaturePage',

  components: {
    FeatureSection,
    OLayout,
    OLayoutSider,
    OLayoutContent,
    OHeading,
    ONav,
    ONavLink,
    OAccordion,
  },

  props: {
    pageData: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    sections() {
      let sections = [];

      if (this.pageData.sections) {
        // This will create a sections array filled with
        // arrays that each contain either one or two sections.
        // This is to make the design of the feautures pages
        // default to one main column on top, with sections below
        // that contain any number of columns
        sections = [this.pageData.sections.slice(0, 1)];
        const numColumns = 1;
        const restOfSections = this.pageData.sections.slice(1);

        for (
          let index = 0;
          index < restOfSections.length;
          index += numColumns
        ) {
          sections.push(restOfSections.slice(index, numColumns + index));
        }
      }

      return sections;
    },
  },
};
</script>

<style lang="scss" module="$s">
.NavLinks {
  li {
    white-space: normal;
  }
}

.FeatureContainer {
  .Sidebar {
    display: none;
    padding-left: var(--space-x3);
    padding-right: 0;

    @media (--for-tablet-portrait-up) {
      display: block;
    }

    // Universal Selector is to override orbit
    * {
      font-size: 16px;
    }
  }
}

.MobileMenu {
  display: block;
  margin-bottom: var(--space-x3);

  @media (--for-tablet-portrait-up) {
    display: none;
  }
}
</style>
